/* eslint-disable @typescript-eslint/no-unsafe-return */
import { joinPath } from "../../utils/string";
import { SoapService, BaseEaiwsService } from "../SoapService";
import { AddressData, AutoSaveOptions, ContactData, CountryData, PriceList, ProjectData, ProjectGroup, ProjectNumberScheme, ProjectText, SubdivisionData } from "./ProjectTypes";
export class ProjectService extends BaseEaiwsService {
    constructor(pOwner, pBaseUrl, pSessionId) {
        super(pOwner, joinPath(pBaseUrl, "EAI/Project"), "http://project.ws.eai.egr/", pSessionId);
    }
    addPriceList(pId, pStartup, pDisplayName) {
        const tPromise = this.soapAjax("addPriceList", {
            sessionId: this.mSessionId,
            id: pId,
            startup: pStartup,
            displayName: pDisplayName
        });
        return (tPromise);
    }
    addProjectGroup(pId, pFolder, pSimpleName, pSubgroupTitle) {
        const tPromise = this.soapAjax("addProjectGroup", {
            sessionId: this.mSessionId,
            id: pId,
            folder: pFolder,
            simpleName: pSimpleName,
            subgroupTitle: pSubgroupTitle
        });
        return (tPromise);
    }
    addProjectNumberScheme(pId, pPattern, pMinValue, pMaxValue) {
        const tPromise = this.soapAjax("addProjectNumberScheme", {
            sessionId: this.mSessionId,
            id: pId,
            pattern: pPattern,
            minValue: pMinValue,
            maxValue: pMaxValue
        });
        return (tPromise);
    }
    authenticateUser(pMessageType, pMessage) {
        const tPromise = this.soapAjax("authenticateUser", {
            sessionId: this.mSessionId,
            messageType: pMessageType,
            message: pMessage
        });
        return (tPromise);
    }
    deleteProjects(pUris, pOptions) {
        const tPromise = this.soapAjax("deleteProjects", {
            sessionId: this.mSessionId,
            uris: pUris,
            options: pOptions
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    getAddressData(pAddressTypes) {
        const tPromise = this.soapAjax("getAddressData", {
            sessionId: this.mSessionId,
            addressTypes: pAddressTypes
        }).then((pResponse) => {
            return (AddressData.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getContactData() {
        const tPromise = this.soapAjax("getContactData", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            return (ContactData.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getCountries() {
        const tPromise = this.soapAjax("getCountries", {
            sessionId: this.mSessionId
        }).then((pResponse) => {
            return (CountryData.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getCountrySubdivisions(pCountryCode) {
        const tPromise = this.soapAjax("getCountrySubdivisions", {
            sessionId: this.mSessionId,
            countryCode: pCountryCode
        }).then((pResponse) => {
            return (SubdivisionData.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getPriceLists(pIdPattern) {
        const tPromise = this.soapAjax("getPriceLists", {
            sessionId: this.mSessionId,
            idPattern: pIdPattern
        }).then((pResponse) => {
            return (PriceList.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getProjectData(pTextFormat) {
        const tPromise = this.soapAjax("getProjectData", {
            sessionId: this.mSessionId,
            textFormat: pTextFormat
        }).then((pResponse) => {
            return (ProjectData.FromSoap(pResponse));
        });
        return (tPromise);
    }
    getProjectGroups(pIdPattern) {
        const tPromise = this.soapAjax("getProjectGroups", {
            sessionId: this.mSessionId,
            idPattern: pIdPattern
        }).then((pResponse) => {
            return (ProjectGroup.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getProjectNumberSchemes(pIdPattern) {
        const tPromise = this.soapAjax("getProjectNumberSchemes", {
            sessionId: this.mSessionId,
            idPattern: pIdPattern
        }).then((pResponse) => {
            return (ProjectNumberScheme.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    getProjectTexts(pTextFormat, pTextTypes) {
        const tPromise = this.soapAjax("getProjectTexts", {
            sessionId: this.mSessionId,
            textTypes: pTextTypes,
            textFormat: pTextFormat
        }).then((pResponse) => {
            return (ProjectText.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    listCompletions(pOptions) {
        const tPromise = this.soapAjax("listCompletions", {
            sessionId: this.mSessionId,
            options: pOptions
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    listProjects(pOptions) {
        const tPromise = this.soapAjax("listProjects", {
            sessionId: this.mSessionId,
            options: pOptions
        }).then((pResponse) => {
            return (ProjectData.FromSoapArrayNU(pResponse));
        });
        return (tPromise);
    }
    loadProject(pUri, pLockMode) {
        const tPromise = this.soapAjax("loadProject", {
            sessionId: this.mSessionId,
            uri: pUri,
            lockMode: pLockMode
        });
        return (tPromise);
    }
    newProject(pProjectGroup, pPriceList) {
        const tPromise = this.soapAjax("newProject", {
            sessionId: this.mSessionId,
            projectGroup: pProjectGroup,
            priceList: pPriceList
        });
        return (tPromise);
    }
    removeAddressData(pAddressTypes) {
        const tPromise = this.soapAjax("removeAddressData", {
            sessionId: this.mSessionId,
            addressTypes: pAddressTypes
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse));
        });
        return (tPromise);
    }
    removeContactData(pAddressType, pContactIds) {
        const tPromise = this.soapAjax("removeContactData", {
            sessionId: this.mSessionId,
            addressType: pAddressType,
            contactIds: pContactIds
        }).then((pResponse) => {
            return (SoapService.SoapDataToArrayNU(pResponse, SoapService.SoapDataToInt));
        });
        return (tPromise);
    }
    removePriceList(pId) {
        const tPromise = this.soapAjax("removePriceList", {
            sessionId: this.mSessionId,
            id: pId
        });
        return (tPromise);
    }
    removeProjectGroup(pId) {
        const tPromise = this.soapAjax("removeProjectGroup", {
            sessionId: this.mSessionId,
            id: pId
        });
        return (tPromise);
    }
    removeProjectNumberScheme(pId) {
        const tPromise = this.soapAjax("removeProjectNumberScheme", {
            sessionId: this.mSessionId,
            id: pId
        });
        return (tPromise);
    }
    saveProject(pOptions) {
        const tPromise = this.soapAjax("saveProject", {
            sessionId: this.mSessionId,
            options: pOptions
        });
        return (tPromise);
    }
    setAddressData(pAddress) {
        const tPromise = this.soapAjax("setAddressData", {
            sessionId: this.mSessionId,
            address: pAddress
        });
        return (tPromise);
    }
    setAutoSaveOptions(pOptions) {
        const tPromise = this.soapAjax("setAutoSaveOptions", {
            sessionId: this.mSessionId,
            options: pOptions
        }).then((pResponse) => {
            return (AutoSaveOptions.FromSoap(pResponse));
        });
        return (tPromise);
    }
    setContactData(pContact) {
        const tPromise = this.soapAjax("setContactData", {
            sessionId: this.mSessionId,
            contact: pContact
        });
        return (tPromise);
    }
    setProjectData(pData) {
        const tPromise = this.soapAjax("setProjectData", {
            sessionId: this.mSessionId,
            data: pData
        });
        return (tPromise);
    }
    setProjectText(pText, pUpdate) {
        const tPromise = this.soapAjax("setProjectText", {
            sessionId: this.mSessionId,
            text: pText,
            update: pUpdate
        });
        return (tPromise);
    }
    updatePriceList(pPriceList) {
        const tPromise = this.soapAjax("updatePriceList", {
            sessionId: this.mSessionId,
            priceList: pPriceList
        });
        return (tPromise);
    }
    updateProjectGroup(pProjectGroup) {
        const tPromise = this.soapAjax("updateProjectGroup", {
            sessionId: this.mSessionId,
            projectGroup: pProjectGroup
        });
        return (tPromise);
    }
    updateProjectLock(pLockMode) {
        const tPromise = this.soapAjax("updateProjectLock", {
            sessionId: this.mSessionId,
            lockMode: pLockMode
        }).then((pResponse) => {
            return (SoapService.SoapDataToBool(pResponse));
        });
        return (tPromise);
    }
    updateProjectNumberScheme(pNumberScheme) {
        const tPromise = this.soapAjax("updateProjectNumberScheme", {
            sessionId: this.mSessionId,
            numberScheme: pNumberScheme
        });
        return (tPromise);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _clearCache() {
    }
}
